<template>
  <div class="footer">
    <el-footer style="height: auto; padding-top: 10px">
      <div style="display: none">
        <el-link :underline="false" href="/events">会议活动</el-link>
        <el-link :underline="false">登录</el-link>
        <el-link :underline="false">注册</el-link>
        <el-link :underline="false">联系我们</el-link>
      </div>
      <!-- <div class="footer_logo">
        <div class="site_name">{{ siteName }}</div>
      </div> -->
      <div class="footer_desc">
        中国经济学年会投稿报名系统是综合会务发布、管理、日程安排、会议报名、论文投稿等功能的会议系统平台。联系邮箱：cea@pku.edu.cn
      </div>
      <div class="copyright">
        <span style="margin-right: 20px">Copyright © {{ copyrightText }}</span
        >{{ icpNum }}
      </div>
    </el-footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      siteName: '中国经济学年会投稿报名系统',
      copyrightText: '中国经济学年会',
      icpNum: '',
    };
  },
};
</script>

<style scoped></style>
